import React from 'react';
import { specialtyVisual } from '../../pages/landing/specialtyMeta';
import BookingDoctorCard from './BookingDoctorCard';

export function BookingStepRail({ step, primary }) {
  const steps = ['Specialty', 'Doctor', 'Date & time', 'Your details'];
  return (
    <div className="flex items-center gap-1.5 mb-5 overflow-x-auto pb-1" data-testid="booking-steps">
      {steps.map((label, i) => {
        const n = i + 1;
        const active = step === n;
        const done = step > n;
        return (
          <div key={label} className="flex items-center gap-1.5 flex-shrink-0">
            {i > 0 && <div className={`w-4 h-px ${done || active ? 'bg-white/30' : 'bg-white/10'}`} />}
            <div
              className={`flex items-center gap-1.5 px-2 py-1 rounded-full text-[10px] uppercase tracking-wide ${
                active ? 'text-white' : done ? 'text-zinc-300' : 'text-zinc-600'
              }`}
              style={active ? { background: `${primary}33`, color: primary } : {}}
            >
              <span
                className={`h-4 w-4 rounded-full text-[9px] font-bold flex items-center justify-center ${
                  active || done ? 'text-white' : 'bg-white/10 text-zinc-500'
                }`}
                style={active || done ? { background: primary } : {}}
              >
                {n}
              </span>
              {label}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function BookingSpecialtyStep({ specialties, primary, onPick }) {
  return (
    <div data-testid="booking-specialty-step">
      <p className="text-[11px] uppercase tracking-wider text-zinc-400 mb-3">What do you need care for?</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {specialties.map(({ specialty, doctors }) => {
          const { Icon, hint } = specialtyVisual(specialty);
          return (
            <button
              key={specialty}
              type="button"
              onClick={() => onPick(specialty)}
              className="text-left rounded-xl border border-white/12 bg-white/[0.03] hover:bg-white/[0.07] p-3.5 transition"
              data-testid={`booking-specialty-${specialty}`}
            >
              <div className="flex items-start gap-3">
                <div
                  className="h-9 w-9 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ background: `${primary}22`, color: primary }}
                >
                  <Icon className="h-4 w-4" />
                </div>
                <div className="min-w-0">
                  <p className="font-semibold text-zinc-100 text-sm">{specialty}</p>
                  <p className="text-[11px] text-zinc-500 mt-0.5 line-clamp-1">{hint}</p>
                  <p className="text-[10px] text-zinc-600 mt-1">{doctors.length} available</p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function BookingDoctorStep({ doctors, profilesById = {}, pickedId, primary, onPick, onBack }) {
  return (
    <div data-testid="booking-doctor-step">
      <div className="flex items-center justify-between mb-3">
        <p className="text-[11px] uppercase tracking-wider text-zinc-400">Choose a doctor</p>
        <button type="button" onClick={onBack} className="text-[11px] text-zinc-500 hover:text-zinc-300">
          Change specialty
        </button>
      </div>
      <div className="space-y-2">
        {doctors.map((d) => {
          const active = pickedId === d.id;
          const profile = profilesById[d.id] || profilesById[`name:${d.name}`] || {};
          return (
            <button
              key={d.id}
              type="button"
              onClick={() => onPick(d)}
              className={`w-full text-left rounded-xl border px-3.5 py-3 transition ${
                active ? 'border-white/40 bg-white/10' : 'border-white/12 hover:bg-white/[0.06]'
              }`}
              style={active ? { borderColor: primary, background: `${primary}18` } : {}}
              data-testid={`booking-doctor-${d.id}`}
            >
              <BookingDoctorCard
                doctor={{ ...d, ...profile, name: d.name, spec: d.spec }}
                active={active}
                primary={primary}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
}
